const $ = require('jquery');

var common = {};

/**
 * Get form inputs as object
 * @param selector
 */
common.getInputs = function (selector) {
  var form = {};
  $(selector).each(function(index){ 
    var input = $(this); 
    form[input.attr('name')] = input.val();

    
    // // checkbox should be checked this way
    if (input.attr('type') == 'checkbox') {
      form[input.attr('name')] = input.is(':checked') ? true : false;
    }
  });
  return form;
}

/**
 * Get pathname
 */
common.getPathname = function () {
  return window.location.pathname;
}

module.exports = common;